<template>
  <v-autocomplete
    item-value="id"
    item-text="libelle"
    placeholder="Commencer à saisir pour lancer la recherche"
    v-model="commune"
    :loading="loading"
    :search-input.sync="recherche"
    :items="communes"
    no-filter
    return-object
    v-bind="$attrs"
    v-on="$listeners"
    :data-testid="dataTestid"
  ></v-autocomplete>
</template>

<script>
import _ from "lodash";
import { communeService } from "@/services";
export default {
  props: {
    "data-testid": {
      type: String,
      required: false,
    },
    value: {
      type: Object,
      required: false,
    },
    codePostal: {
      type: String,
      required: false,
    },
  },

  data() {
    return {
      loading: false,
      items: [],
      recherche: null,
      commune: this.value,
    };
  },

  mounted() {
    this.debouncedQuery = _.debounce(this.query.bind(this), 250);
  },

  methods: {
    query(recherche, codePostal) {
      if (
        this.commune?.libelle === recherche &&
        !this.items.length &&
        this.communes.length === 1
      ) {
        return;
      }

      this.loading = true;
      communeService
        .autocomplete(recherche, {  codePostal })
        .then(items => {
          this.items = items;
          if(this.commune?.id && !this.communeValide) {
            this.commune = null;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    demarreRecherche() {
      this.debouncedQuery(this.recherche, this.codePostal);
    },
  },

  watch: {
    recherche() {
      this.demarreRecherche();
    },
    codePostal() {
      this.recherche = null;
      this.commune = null;
      this.demarreRecherche();
    },
    value() {
      if (this.codePostal) {
        this.commune = this.value;
      }
    },
    commune() {
      const idValue = this.value?.id;
      const idCommune = this.commune?.id;
      if (idValue !== idCommune) {
        this.$emit("input", this.commune, this.codePostal);
      }
    },
  },

  computed: {
    communeValide() {
      return (this.items || []).find(item => item.id === this.commune.id);
    },
    communes() {
      const communes = [...this.items];
      if (this.value && communes.findIndex(c => c.id === this.value.id) < 0) {
        communes.push(this.value);
      }
      return communes;
    },
  },
};
</script>

